import { PenLine } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { Button, PageHeader } from '@/components/ui'
import { TemplatesSection } from '@/pages/vertraege/sections/TemplatesSection.tsx'

export function VertragsvorlagenPage() {
  const navigate = useNavigate()

  return (
    <div className="p-6 space-y-6">
      <PageHeader
        title="Vorlagenbibliothek"
        description="DOCX-Vorlagen mit Platzhaltern verwalten, versionieren und an Kunden versenden."
        breadcrumbs={[
          { label: 'Stammdaten' },
          { label: 'Vorlagenbibliothek' },
        ]}
        actions={
          <Button
            variant="secondary"
            size="sm"
            leadingIcon={<PenLine className="w-4 h-4" />}
            onClick={() => navigate('/stammdaten/vertragsvorlagen/editor')}
          >
            Vorlagen-Editor
          </Button>
        }
      />

      <TemplatesSection />
    </div>
  )
}
